'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PUBLIC_BOOK_ENDPOINT = exports.PUBLIC_BOOK_ENDPOINT = 'meetings/v1/public/book';
var LINK_ENDPOINT = exports.LINK_ENDPOINT = 'meetings/v1/link';

var BRANDING_ENDPOINT = exports.BRANDING_ENDPOINT = 'branding/v1';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/constants/endpoints.js
// module id = 191
// module chunks = 0